import { useEffect, useState } from "react";

interface User {
  Id: string;
  Token: string;
  expiryDate: string;
  Role: string;
  UserName?: string;
}

const useAuth = () => {
    const [user, setUser] = useState<User>(JSON.parse(localStorage.getItem('admin-auth') || '{}' ) as User);

    useEffect(() => {
        localStorage.setItem('admin-auth', JSON.stringify(user));
    }, [user]);

    return {user, setUser};
}

export default useAuth; 